export default "__VITE_ASSET__CvmFm1gp__"